import { takeLatest, call, put } from 'redux-saga/effects'

import I18n from 'i18n'
import { ICourseModel } from 'models/course.model'
import createCourse from 'api/administration/courses/Create'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../actions/courses.action'

async function handleCreateCourse(course: ICourseModel) {
  return await createCourse(course)
}

function* newCourseEffectSaga(action: any) {
  try {
    const {
      data: {
        data: { id },
      },
    } = yield call(handleCreateCourse, action.payload.course)
    const {
      payload: { history, onlySave },
    } = action

    if (onlySave) {
      history.push('/administration/courses/')
    } else {
      history.push(`/administration/courses/${id}/lessons/`)
    }
  } catch (error) {
    yield put(fromActions.Actions.setCourseLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.courseCreateError'))
    console.log('error: ', error)
  }
}

export function* newCourseWatcherSaga() {
  yield takeLatest(fromActions.CREATE_COURSE, newCourseEffectSaga)
}
